import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Loads usage charges from API with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Usage charges data or null if error
 */
export const loadUsageChargesData = async (notifyError) => {
    // apiCall already extracts results.data || results, so return it directly
    // If the API response is { data: { data: [...] } }, apiCall returns { data: [...] }
    // If the API response is { data: [...] }, apiCall returns [...]
    // If the API response is [...], apiCall returns [...]
    const results = await apiCall(
        url.GET_USAGE_CHARGES,
        'GET',
        null,
        notifyError,
        "Failed to load usage charges"
    );

    // Handle nested data structure if apiCall returns { data: [...] }
    if (results && typeof results === 'object' && !Array.isArray(results) && results.data) {
        return Array.isArray(results.data) ? results.data : results;
    }

    return results;
};

